// The refusal reason the backend puts on an entry blocked by workspace SSO enforcement. The
// frontend matches it to show the sign-in screen instead of a 404, so the literal is a contract
// between the two apps rather than free text.
export const WORKSPACE_SSO_ENFORCED_REASON = "WORKSPACE_SSO_ENFORCED";
